"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const get_1 = __importDefault(require("lodash/get"));
const mobx_1 = require("mobx");
const API_STATE_1 = __importDefault(require("../constants/app/API_STATE"));
const mapInitialStateToStoreState_1 = __importDefault(require("../utils/store/mapInitialStateToStoreState"));
class LocationStore {
    constructor(initialState) {
        this.location = {};
        this.apiState = API_STATE_1.default.INITIAL;
        this.errorData = {};
        /**
         * Detect user location action
         */
        this.detectLocation = () => {
            try {
                this.apiState = API_STATE_1.default.LOADING;
                this.location = {};
                this.errorData = {};
                navigator.geolocation.getCurrentPosition(this.onSuccess, this.onError);
            }
            catch (err) {
                this.onError(err);
            }
        };
        /**
         * Clear Location props
         */
        this.clearLocationProps = () => {
            this.apiState = API_STATE_1.default.INITIAL;
            this.location = {};
            this.errorData = {};
        };
        /**
         * Location success handler
         * @param position {PositionType}
         */
        this.onSuccess = (position) => {
            this.apiState = API_STATE_1.default.SUCCESS;
            this.location = (0, get_1.default)(position, 'coords', {});
        };
        /**
         * Location error handler
         * @param err {LocationErrorType}
         */
        this.onError = (err) => {
            this.apiState = API_STATE_1.default.FAILED;
            // if it is a location error
            if (err.code) {
                this.errorData = err;
                //   switch(error.code) {
                //     case error.PERMISSION_DENIED:
                //       "User denied the request for Geolocation."
                //       break;
                //     case error.POSITION_UNAVAILABLE:
                //       "Location information is unavailable."
                //       break;
                //     case error.TIMEOUT:
                //       "The request to get user location timed out."
                //       break;
                //     case error.UNKNOWN_ERROR:
                //       "An unknown error occurred."
                //       break;
                //   }
            }
            else {
                this.errorData = {
                    code: 999,
                    message: 'unknown error',
                };
            }
        };
        /**
         * Map initial state to store state
         * @param initialState
         */
        this.updateInitialState = (initialState) => {
            (0, mapInitialStateToStoreState_1.default)(this, initialState);
        };
        this.updateInitialState(initialState);
    }
    /**
     * Returns the location loading status
     * @returns {Boolean}
     */
    get isLoading() {
        return this.apiState === API_STATE_1.default.LOADING;
    }
    /**
     * Returns if location fetch was success
     * @returns {Boolean}
     */
    get isSuccess() {
        return this.apiState === API_STATE_1.default.SUCCESS;
    }
    /**
     * Returns if location fetch has failed
     * @returns {Boolean}
     */
    get hasFailed() {
        return this.apiState === API_STATE_1.default.FAILED;
    }
    /**
     * Returns the latitude
     */
    get lat() {
        return (0, get_1.default)(this.location, 'latitude', 0);
    }
    /**
     * Returns the longitude
     */
    get long() {
        return (0, get_1.default)(this.location, 'longitude', 0);
    }
    /**
     * Returns the accuracy
     */
    get accuracy() {
        return (0, get_1.default)(this.location, 'accuracy', 0);
    }
}
__decorate([
    mobx_1.observable
], LocationStore.prototype, "location", void 0);
__decorate([
    mobx_1.observable
], LocationStore.prototype, "apiState", void 0);
__decorate([
    mobx_1.observable
], LocationStore.prototype, "errorData", void 0);
__decorate([
    mobx_1.computed
], LocationStore.prototype, "isLoading", null);
__decorate([
    mobx_1.computed
], LocationStore.prototype, "isSuccess", null);
__decorate([
    mobx_1.computed
], LocationStore.prototype, "hasFailed", null);
__decorate([
    mobx_1.computed
], LocationStore.prototype, "lat", null);
__decorate([
    mobx_1.computed
], LocationStore.prototype, "long", null);
__decorate([
    mobx_1.computed
], LocationStore.prototype, "accuracy", null);
__decorate([
    mobx_1.action.bound
], LocationStore.prototype, "detectLocation", void 0);
__decorate([
    mobx_1.action.bound
], LocationStore.prototype, "clearLocationProps", void 0);
__decorate([
    mobx_1.action.bound
], LocationStore.prototype, "onSuccess", void 0);
__decorate([
    mobx_1.action.bound
], LocationStore.prototype, "onError", void 0);
__decorate([
    mobx_1.action.bound
], LocationStore.prototype, "updateInitialState", void 0);
exports.default = LocationStore;
